<p-card styleClass="p-4">
  <ng-template pTemplate="header">
    <div class="flex justify-between">
      <h2>My Call Stats</h2>
      <app-icon-button 
        [icon]="icons.solid.faGear" 
        tooltip="Update My Call Goals" 
        tooltipPosition="top"
        (click)="updateMyCallGoals()"
      ></app-icon-button>
    </div>
  </ng-template>
  <div class="flex flex-col gap-4">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <!-- Week Stats -->
      <div class="flex flex-col items-center text-center">
        <div class="stat-info">
          <div class="stat-header">
            <span class="stat-title">This Week</span>
          </div>
          <div class="stat-description flex flex-col gap-1">
            <div class="stat-subtitle">
              <span class="goal-label">Goal:</span> {{goals.week | number}}
            </div>
            <div class="stat-count">
              {{weekStats.totalCalls | number}} calls, {{weekStats.totalMeetings | number}} meetings
            </div>
          </div>
        </div>
        <div class="stat-knob">
          <p-knob 
            [(ngModel)]="weekPercentage" 
            [readonly]="true"
            [size]="100"
            [strokeWidth]="10"
            [showValue]="true"
            [valueTemplate]="'{value}%'">
          </p-knob>
        </div>
      </div>

      <!-- Month Stats -->
      <div class="flex flex-col items-center text-center">
        <div class="stat-info">
          <div class="stat-header">
            <span class="stat-title">{{currentMonth}}</span>
          </div>
          <div class="stat-description flex flex-col gap-1">
            <div class="stat-subtitle">
              <span class="goal-label">Goal:</span> {{goals.month | number}}
            </div>
            <div class="stat-count">
              {{monthStats.totalCalls | number}} calls, {{monthStats.totalMeetings | number}} meetings
            </div>
          </div>
        </div>
        <div class="stat-knob">
          <p-knob 
            [(ngModel)]="monthPercentage" 
            [readonly]="true"
            [size]="100"
            [strokeWidth]="10"
            [showValue]="true"
            [valueTemplate]="'{value}%'">
          </p-knob>
        </div>
      </div>

      <!-- Year Stats -->
      <div class="flex flex-col items-center text-center">
        <div class="stat-info">
          <div class="stat-header">
            <span class="stat-title">{{currentYear}}</span>
          </div>
          <div class="stat-description flex flex-col gap-1">
            <div class="stat-subtitle">
              <span class="goal-label">Goal:</span> {{goals.year | number}}
            </div>
            <div class="stat-count">
              {{yearStats.totalCalls | number}} calls, {{yearStats.totalMeetings | number}} meetings
            </div>
          </div>
        </div>
        <div class="stat-knob">
          <p-knob 
            [(ngModel)]="yearPercentage" 
            [readonly]="true"
            [size]="100"
            [strokeWidth]="10"
            [showValue]="true"
            [valueTemplate]="'{value}%'">
          </p-knob>
        </div>
      </div>
    </div>
  </div>
</p-card> 